import { FormFieldVariants } from "./types";

export const FORM_FIELD_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]: "",
};

export const TEXT_INPUT_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]:
    "inline-block no-scrollbar w-full py-4 px-6 rounded-2xl text-base font-medium outline-none placeholder:text-black-base placeholder:font-medium",
};

export const LABEL_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]: "",
};
